var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAcknowledge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M281.309 259.894L361.934 340.799C373.65 352.515 373.65 371.51 361.934 383.225C350.218 394.941 331.223 394.941 319.508 383.225L238.743 302.46M238.603 302.6L291.868 355.865C303.584 367.581 303.584 386.576 291.868 398.291C280.152 410.007 261.157 410.007 249.442 398.291L211.734 360.583M77 136.428H175.73M437 113.428H497V357.428H437V113.428Z",
    stroke: "white",
    strokeWidth: 30,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M212.013 360.303L216.069 364.359C227.785 376.075 227.785 395.07 216.069 406.785C204.353 418.501 185.358 418.501 173.643 406.785L94.634 327.776H73M281.309 259.894L385.787 364.372C397.503 376.088 416.498 376.088 428.213 364.372C439.929 352.656 439.929 333.661 428.213 321.946L287.673 181.406H246.73L245.789 182.145C214.137 207.027 169.048 205.022 139.73 177.429L214.73 96.429H327.73L389.73 150.429H429.73",
    stroke: "white",
    strokeWidth: 30,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 113.428H75V357.428H15V113.428Z",
    stroke: "white",
    strokeWidth: 30,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcknowledge);
export default __webpack_public_path__ + "static/media/acknowledge.360669b0427457ef0427dd5580713045.svg";
export { ForwardRef as ReactComponent };